import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface PageContainerProps {
  children: React.ReactNode;
  /**
   * Cap and centre the content column. Omit for full-bleed list and table
   * pages; pass a value for forms and reading-width pages.
   */
  maxWidth?: number;
  sx?: SxProps<Theme>;
}

/**
 * The outer wrapper every signed-in page renders inside the app shell.
 *
 * Pages used to pick their own padding (p: 3, px/py, responsive variants) and
 * their own column widths, so adjacent pages sat at different gutters. This
 * owns both, and inherits the page background painted by the shell rather
 * than declaring one.
 *
 * `minWidth: 0` / `maxWidth: 100%` keep a wide table from stretching the page
 * past the shell's scroll area; the table scrolls inside its own container.
 */
export const PageContainer: React.FC<PageContainerProps> = ({ children, maxWidth, sx }) => (
  <Box
    sx={[
      { p: { xs: 2, md: 3 }, width: '100%', minWidth: 0, boxSizing: 'border-box' },
      maxWidth !== undefined && { maxWidth, mx: 'auto' },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);
